module.exports = __webpack_public_path__ + "static/img/mobile.3e3b7558.png";